import type { Trip, Stop } from '../types'

// Demo trip calculation
export const DEMO_CALCULATION = {
  totalDistance: 650000, // 650 km in meters
  totalDuration: 480, // 8 hours in minutes
  totalFuelCost: 60.50, // Changed from fuelCost to totalFuelCost
  segments: [
    { distance: 120000, duration: 90 }, // Budapest → MOL
    { distance: 90000, duration: 60 },  // MOL → Wien
    { distance: 5000, duration: 15 },   // Wien → Hotel
    { distance: 8000, duration: 20 },   // Hotel → Schönbrunn
    { distance: 300000, duration: 180 }, // Schönbrunn → Praha
  ]
}

export const DEMO_TRIP: Trip = {
  id: 'demo-trip-1',
  name: 'Budapest → Wien → Praha',
  userId: 'demo-user',
  stops: [],
  totalDistance: 650000, // meters
  totalDuration: 480, // minutes (8 hours)
  totalCost: 85.50,
  fuelConsumption: 7.5,
  fuelPrice: 1.65,
  status: 'active',
  stopCount: 6,
  createdAt: new Date('2024-06-15T08:00:00'),
  updatedAt: new Date('2024-06-15T08:00:00')
}

export const DEMO_STOPS: Stop[] = [
  {
    id: 'demo-stop-1',
    name: 'Budapest',
    address: 'Budapest, Magyarország',
    type: 'city',
    duration: 60,
    lat: 47.4979,
    lng: 19.0402,
    order: 0,
    notes: 'Indulás a fővárosból',
    createdAt: new Date('2024-06-15T08:00:00'),
    updatedAt: new Date('2024-06-15T08:00:00')
  },
  {
    id: 'demo-stop-2',
    name: 'MOL Benzinkút',
    address: 'M1 Autópálya, Győr',
    type: 'gas_station',
    duration: 20,
    lat: 47.6875,
    lng: 17.6504,
    order: 1,
    notes: 'Tankolás és kávé szünet',
    createdAt: new Date('2024-06-15T09:30:00'),
    updatedAt: new Date('2024-06-15T09:30:00')
  },
  {
    id: 'demo-stop-3',
    name: 'Wien',
    address: 'Wien, Ausztria',
    type: 'city',
    duration: 180,
    lat: 48.2082,
    lng: 16.3738,
    order: 2,
    notes: 'Városnézés és ebéd',
    createdAt: new Date('2024-06-15T11:00:00'),
    updatedAt: new Date('2024-06-15T11:00:00')
  },
  {
    id: 'demo-stop-4',
    name: 'Hotel Am Ring',
    address: 'Kärtner Ring 8, Wien',
    type: 'hotel',
    duration: 720, // 12 hours overnight
    lat: 48.2010,
    lng: 16.3720,
    order: 3,
    notes: 'Éjszakai szállás a belvárosban',
    createdAt: new Date('2024-06-15T18:00:00'),
    updatedAt: new Date('2024-06-15T18:00:00')
  },
  {
    id: 'demo-stop-5',
    name: 'Schönbrunn Palace',
    address: 'Schönbrunner Schloßstraße, Wien',
    type: 'attraction',
    duration: 120,
    lat: 48.1847,
    lng: 16.3122,
    order: 4,
    notes: 'Kastély látogatás',
    createdAt: new Date('2024-06-16T10:00:00'),
    updatedAt: new Date('2024-06-16T10:00:00')
  },
  {
    id: 'demo-stop-6',
    name: 'Praha',
    address: 'Praha, Csehország',
    type: 'city',
    duration: 240,
    lat: 50.0755,
    lng: 14.4378,
    order: 5,
    notes: 'Célállomás - Prágai városnézés',
    createdAt: new Date('2024-06-16T15:00:00'),
    updatedAt: new Date('2024-06-16T15:00:00')
  }
]

// Add stops to the trip
DEMO_TRIP.stops = DEMO_STOPS

export const isDemoMode = () => {
  // Check if user is not authenticated
  return !localStorage.getItem('supabase.auth.token')
}

export const getDemoTrip = (): Trip => {
  return { ...DEMO_TRIP, stops: [...DEMO_STOPS] }
}

export const getDemoStops = (): Stop[] => {
  return [...DEMO_STOPS]
}

export const getDemoCalculation = () => {
  return { ...DEMO_CALCULATION }
}
